import {
    EXPORT_PRE_EMBAUCHE_DOCUMENT_PDF_SUCCESS,
    FETCH_PRE_EMBAUCHE_DOCUMENT_SUCCESS,
    GENERATE_PRE_EMBAUCHE_DOCUMENT_SUCCESS,
    SET_PRE_EMBAUCHE_ERROR,
    SET_PRE_EMBAUCHE_LOADING,
    UPDATE_PRE_EMBAUCHE_DOCUMENT_SUCCESS,
    UPDATE_PRE_EMBAUCHE_PROCEDURE_STEP_SUCCESS,
} from "../actions/preEmbaucheActions";

const initialState = {
    loadingByKey: {},
    errorByKey: {},
    lettreConfirmationByCandidature: {},
    contratTravailByCandidature: {},
    procedureIntegrationByCandidature: {},
};

const getStateKey = (documentType) => {
    switch (documentType) {
        case "lettreConfirmation":
            return "lettreConfirmationByCandidature";
        case "contratTravail":
            return "contratTravailByCandidature";
        case "procedureIntegration":
            return "procedureIntegrationByCandidature";
        default:
            return null;
    }
};

const mergeDocument = (state, action) => {
    const stateKey = getStateKey(action.payload.documentType);
    if (!stateKey || !action.payload.candidatureId || !action.payload.data) {
        return state;
    }

    return {
        ...state,
        [stateKey]: {
            ...state[stateKey],
            [action.payload.candidatureId]: action.payload.data,
        },
    };
};

export default function preEmbaucheReducer(state = initialState, action) {
    switch (action.type) {
        case SET_PRE_EMBAUCHE_LOADING:
            return {
                ...state,
                loadingByKey: {
                    ...state.loadingByKey,
                    [action.payload.key]: action.payload.value,
                },
            };

        case SET_PRE_EMBAUCHE_ERROR:
            return {
                ...state,
                errorByKey: {
                    ...state.errorByKey,
                    [action.payload.key]: action.payload.error,
                },
            };

        case FETCH_PRE_EMBAUCHE_DOCUMENT_SUCCESS:
        case GENERATE_PRE_EMBAUCHE_DOCUMENT_SUCCESS:
        case UPDATE_PRE_EMBAUCHE_DOCUMENT_SUCCESS:
        case EXPORT_PRE_EMBAUCHE_DOCUMENT_PDF_SUCCESS:
        case UPDATE_PRE_EMBAUCHE_PROCEDURE_STEP_SUCCESS:
            return mergeDocument(state, action);

        default:
            return state;
    }
}
